import { render, staticRenderFns } from "./LandsideMain.vue?vue&type=template&id=6e64931e&"
import script from "./LandsideMain.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideMain.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports